import React, { Suspense, lazy } from "react"
import { Route } from "react-router-dom"

const RoleSelectPage = lazy(() => import("./RoleSelectPage"))

const DemoRoute = (
  <Route
    path="/demo/role-select"
    element={
      <Suspense fallback={<div>Loading...</div>}>
        <RoleSelectPage />
      </Suspense>
    }
  />
)

export default DemoRoute
